"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTypeUsesRootKeyEncryption = ContentTypeUsesRootKeyEncryption;
const ContentTypesUsingRootKeyEncryption_1 = require("./ContentTypesUsingRootKeyEncryption");
function ContentTypeUsesRootKeyEncryption(contentType) {
    return (0, ContentTypesUsingRootKeyEncryption_1.ContentTypesUsingRootKeyEncryption)().includes(contentType);
}
